import React from 'react'
import type { ListField } from '@ztechapps/common.hook'

export type BodyCellProps = { children: React.ReactNode; field?: ListField; useTd?: boolean }
export const BodyCell = ({ children, field, useTd = true }: BodyCellProps) => {
  const showField = field?.isVisible
  //do not show the field if it defined on the config
  if (showField === false) return null

  if (!useTd) return children

  return <td>{children}</td>
}
